;
define("global_views_format_payment_method.tpl", function(){});

